import { render, staticRenderFns } from "./CourseShowTeacher.vue?vue&type=template&id=35bf7d22&scoped=true"
import script from "./CourseShowTeacher.vue?vue&type=script&lang=js"
export * from "./CourseShowTeacher.vue?vue&type=script&lang=js"
import style0 from "./CourseShowTeacher.vue?vue&type=style&index=0&id=35bf7d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf7d22",
  null
  
)

export default component.exports